import React, { Suspense } from 'react';
import PropTypes from 'prop-types';

import { LinearProgress } from '@/mui/components';

import styles from './DefaultSuspense.module.scss';

function DefaultSuspense(props) {
  return (
    <Suspense fallback={<LinearProgress color="inherit" className={styles.Suspense} />}>{props.children}</Suspense>
  );
}

DefaultSuspense.propTypes = {
  children: PropTypes.node.isRequired,
};

export default DefaultSuspense;
